module.exports = __webpack_public_path__ + "static/media/verbs_in_ui2.d0472b9d.JPG";